module.exports = __webpack_public_path__ + "media/a5.78a6ac45.wav";